module.exports = __webpack_public_path__ + "img/icon3.e8ed5a3c.png";